<div [formGroup]="parentForm" id="it-tax-withholdings">
    <div id="tax-withholding-title" class="small-bottom-spacer">Tax withholding</div>
    <mm-banners *ngIf="showMassachusettsDistributionWarning" [bannerText]="[stateTaxAttentionRequiredWarningMessage]" [type]="'warning'"></mm-banners>
    <!-- NRA BANNER -->
    <mm-banners *ngIf="nraIndicator" [bannerText]="[nraText]" [type]="'information'"></mm-banners>

    <!-- COMBINED FED AND STATE TAX ERROR -->
    <mm-banners *ngIf="parentForm?.errors" [bannerText]="[fedAndStateTaxSumError]" [type]="'error'" data-testid="fed-and-state-tax-error"></mm-banners>

    <div id="tax-withholding-text" class="medium-bottom-spacer">
        <span>{{taxWithholdingText}}</span>
    </div>

    <div class="row">
        <!-- FED TAX -->
        <div class="tax-container">
            <div *ngIf="!nraIndicator" class="tax-percent" id="federal-percent">
                <div id="federal-tax-label" data-testid="fed-tax-title" [class.error-text]="isFedTaxInvalid">Federal tax</div>

                <input type="text" formControlName="fedTaxPercent" (blur)="onFedTaxBlur()"
                    [class.is-invalid]="fedTaxPercent.invalid"
                    (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                    data-testid="fed-tax-input" maxlength="10">

                <div *ngIf="fedTaxPercent.invalid" class="alert-text" data-testid="fed-tax-error">
                    {{fedTaxError}}
                </div>
            </div>
        </div>
        <!-- STATE TAX -->
        <div id="state-tax-container" data-testid="state-tax-field">
            <div class="tax-container">
                <div class="tax-percent" id="state-percent">
                  <div id="federal-tax-label" data-testid='state-tax-title' [class.error-text]="isStateTaxInvalid">{{saStateTaxLabel}}</div>

                    <input type="text" formControlName="stateTaxPercent" (blur)="onStateTaxBlur()"
                        [class.is-invalid]="stateTaxPercent.invalid"
                        (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                        data-testid="state-tax-input" maxlength="10">

                    <div *ngIf="stateTaxPercent.invalid" class="alert-text" data-testid="state-tax-error">
                        {{stateTaxError}}
                    </div>
                </div>
            </div>
            <!-- VIEW STATE TAX LINK -->
            <div>
                <div id="view-state-tax-info-link">
                    <a href="https://www.schwab.com/resource/state-income-tax-withholding-information-for-individual-retirement-accounts"
                        target="_blank">View state tax information</a>
                </div>
            </div>
        </div>
    </div>
</div>
